import { render } from "./UserSessions.vue?vue&type=template&id=71f07e11&scoped=true"
import script from "./UserSessions.vue?vue&type=script&lang=js"
export * from "./UserSessions.vue?vue&type=script&lang=js"

import "./UserSessions.vue?vue&type=style&index=0&id=71f07e11&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f07e11"]])

export default __exports__